import React, { useRef } from 'react';

import ModalPhotoBase from './ModalPhotoBase';

import PhotoBg from '../../../../../Images/modals/photographers/gregory/bg_gregory.png';
import Photo1 from '../../../../../Images/modals/photographers/gregory/photo-1.png';
import Photo2 from '../../../../../Images/modals/photographers/gregory/photo-2.png';
import Photo3 from '../../../../../Images/modals/photographers/gregory/photo-3.png';
import Photo4 from '../../../../../Images/modals/photographers/gregory/photo-4.png';

import {
  Photo_Gregory,
  Text_Gregory,
  TextPhoto1_Gregory,
  TextPhoto2_Gregory,
  TextPhoto3_Gregory,
  TextPhoto4_Gregory,
} from '../../../../../utils/EN/Modals/photographers';

const ModalGregory = () => {
  return (
    <>
      <ModalPhotoBase
        id="photo-gregory"
        mainBg={PhotoBg}
        directorName={Photo_Gregory}
        mainVideoBg={Photo1}
        videoText1={TextPhoto1_Gregory}
        directorText={Text_Gregory}
        rowImage1={Photo2}
        videoText2={TextPhoto2_Gregory}
        rowImage2={Photo3}
        videoText3={TextPhoto3_Gregory}
        rowImage3={Photo4}
        videoText4={TextPhoto4_Gregory}
        mainGallery={'gregory-gallery-1'}
        gallery2={'gregory-gallery-2'}
        gallery3={'gregory-gallery-3'}
        gallery4={'gregory-gallery-4'}
      />
    </>
  );
};

export default ModalGregory;
